import { css } from 'styled-components';

var SIZE = {
  MOBILE: "320px",
  TABLET: "600px",
  DESKTOP: "1024px"
};
var MEDIA_QUERY = {
  EXCEPT_DESKTOP: "(min-width: ".concat(SIZE.MOBILE, ") and (max-width: ").concat(SIZE.DESKTOP, ")"),
  EXCEPT_MOBILE: "(min-width: ".concat(SIZE.TABLET, ")"),
  ONLY_MOBILE: "(min-width: 0) and (max-width: ".concat(SIZE.TABLET, ")"),
  TABLET: "(min-width: ".concat(SIZE.TABLET, ")"),
  ONLY_TABLET: "(min-width: ".concat(SIZE.TABLET, ") and (max-width: ").concat(SIZE.DESKTOP, ")"),
  ONLY_DESKTOP: "(min-width: ".concat(SIZE.DESKTOP, ")")
};
// NOTE: from cryptobadge.xyz
var mediaSize = {
  mobileSmall: 320,
  // 5S SE
  mobileWide: 360,
  // samsung
  mobileGiant: 415,
  // iphone 6/7/8 plus
  popUp: 640,
  tablet: 768,
  tabletWide: 1024,
  desktop: 1170,
  desktopWide: 1220,
  desktopGiant: 1400,
  giant: 1600,
  giantWide: 1800
};
var media = Object.keys(mediaSize).reduce(function (accumulator, label) {
  var pxSize = mediaSize[label];
  accumulator[label] = function (args) {
    return css(["@media (min-width:", "px){", ";}"], pxSize, css(args));
  };
  return accumulator;
}, {});

export { MEDIA_QUERY, SIZE, media, mediaSize };
